/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import { pxToEm, replacePXinStringWithEM } from '@insticator/insticator-ui'; // iui-utils



/* ++++++++++ --------------- EXPORT : STEP INDICATOR : ARROW STEP : STYLES --------------- ++++++++++ */
export default theme => ({
	arrowstep: {
		background: theme.color.light.light.swatch,
		// borderRight: replacePXinStringWithEM(`1px solid ${theme.color.neutral.light.swatch}`),
		cursor: 'pointer',
		display: 'flex',
		alignItems: 'center',
		justifyContent: 'center',
		height: pxToEm(50),
		// padding: replacePXinStringWithEM(`0px 0px 0px 40px`),
		transition: theme.animation.general('all'),
		position: 'relative',
		flex: replacePXinStringWithEM(`0 0 180px`),

		// ..... DESC ..... //
		'& .desc': {
			display: 'flex',
			alignItems: 'center',
			justifyContent: 'center',
			paddingLeft: pxToEm(40),
			'& .icon': {
				display: 'none', // turned on only if step complete
				color: theme.color.secondary.medium.swatch,
				marginRight: pxToEm(10)
			},
			'& .text': {
				color: theme.color.neutral.medium.swatch,
				fontSize: pxToEm(16),
				fontWeight: 'normal',
				whiteSpace: 'nowrap',
				transition: 'color .2s linear 0s'
			}
		},

		// ..... TRIANGLES ..... //
		// https://css-tricks.com/triangle-breadcrumbs/
		// right triangle
		'&:after, &:before': {
			borderTop: replacePXinStringWithEM(`50px solid transparent`), /* Go big on the size, and let overflow hide */
			borderBottom: replacePXinStringWithEM(`50px solid transparent`),
			borderLeft: replacePXinStringWithEM(`30px solid transparent`),
		},
		'&:after': { 
			content: `" "`, 
			display: 'block',
			width: '0',
			height: '0',
			borderLeftColor: theme.color.light.light.swatch,
			position: 'absolute',
			top: '50%',
			marginTop: pxToEm(-50),
			left: '100%',
			zIndex: '2',
			transition: 'border .2s linear 0s'
		},
		// triangle border
		'&:before': {
			content: `" "`,
			display: 'block',
			width: '0',
			height: '0',
			borderLeftColor: `#E8EBF2`,
			position: 'absolute',
			top: '50%',
			marginTop: pxToEm(-50),
			marginLeft: pxToEm(1),
			left: '100%',
			zIndex: '1'
		},

		// ..... FIRST / LAST STEP ..... //
		'&:first-child': {
			flex: '1 0 auto',
			justifyContent: 'flex-end',
			paddingRight: pxToEm(20),
			'& .desc': { paddingLeft: '0' }
		},
		'&:last-child': {
			flex: '1 0 auto',
			justifyContent: 'flex-start',
			paddingLeft: pxToEm(70),
			'& .desc': { paddingLeft: '0' },
			'&:after, &:before': { display: 'none' }
		},

		// ..... ACTIVE / INACTIVE / HOVER - STATES ..... //
		'&.active': {
			background: '#F1F9FF',
			pointerEvents: 'none',
			'& .desc': { '& .text': { color: theme.color.primary.medium.swatch } },
			'&:after': { borderLeftColor: '#F1F9FF' }
		},
		'&:hover': {
			background: theme.color.secondary.xlight.swatch,
			'& .desc': { '& .text': { color: theme.color.neutral.medium.swatchExtra } },
			'&:after': { borderLeftColor: theme.color.secondary.xlight.swatch }
		},
		'&.isComplete-true': {
			'& .desc': { 
				'& .icon': { display: 'block' },
				'& .text': { color: theme.color.supporting.dark.swatch } 
			}
		},
		'&.code': {
			pointerEvents: 'none' // don't allow users to navigate to code page before finishing the process
		}
	},

	// ((((((((((((((( MEDIA QUERIES ))))))))))))))) //
	[`@media only screen and (min-width:${pxToEm(0)}) and (max-width:${pxToEm(740)})`]: {
		arrowstep: {
			background: 'transparent !important',
			flex: replacePXinStringWithEM(`0 0 0px`),
			padding: replacePXinStringWithEM(`15px 7px 0px 0px !important`),
			justifyContent: 'flex-start',
			height: 'auto',
			'& .desc': {
				paddingLeft: '0',
				'& .icon': {
					fontSize: '90%',
					marginRight: pxToEm(5)
				},
				'& .text': {
					fontSize: pxToEm(14)
				}
			},
			'&:before': {
				display: 'none'
			},
			'&:after': {
				content: '">"',
				border: 'none !important',
				top: '0',
			    left: '0',
			    width: 'auto',
			    height: 'auto',
			    display: 'inline-block',
			    position: 'relative',
			    marginTop: '0',
			    marginLeft: pxToEm(7),
			},
			'&:first-child': {
				flex: '0',
				justifyContent: 'flex-start',
			},
			'&:last-child': {
				flex: '0',
				justifyContent: 'flex-start'
			}
		}
	},
	[`@media only screen and (min-width:${pxToEm(740)}) and (max-width:${pxToEm(940)})`]: {
		arrowstep: {
			flex: replacePXinStringWithEM(`0 0 130px`),
			'& .desc': {
				'& .text': {
					fontSize: pxToEm(16)
				}
			},
			'&:first-child': {
				paddingRight: pxToEm(0)
			},
			'&:last-child': {
				paddingLeft: pxToEm(60)
			}
		}
	}
});
